(() => {
  class ComboDropdownCtrl {

  }
  angular.module('pims')
    .component('comboDropdown', {
      templateUrl: 'app/views/services/questionnaire/combo-dropdown-template.tpl.html',
      controller: ComboDropdownCtrl,
      controllerAs: 'vm',
      bindings: {
        dropdown: '=',
        updateOutOperand: '&',
        addAnswerSection: '&',
        addDropdown: '&',
        updateInOperand: '&',
        removeAnswerSection: '&',
        parent: '=',
        question: '<',
        formatExpression: '&',
      },
    });
})();
